<template>
    <div class="col-12 col-lg-8 order-lg-1">
        <div class="alert__block" v-show="alert !== ''">
            <div class="alert__block_header">
                <h3 class="h_text">{{ get_translation_constant('text_dear_customer') }}</h3>
                <div class="alert__block_close" @click="alert=''">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z"
                            fill="#000"/>
                    </svg>
                </div>
            </div>
            <pre>{{ alert }}</pre>
        </div>

        <div class="simple__block">
            <h3 class="h5">{{ get_translation_constant('text_add_new_order') }}</h3>

            <form action="">
                <div class="form__col" :class="hasError('track_code')">
                    <div class="row">
                        <div class="col-12 col-lg-5">
                            <label>{{ get_translation_constant('text_tracking_number_full') }}<sup>*</sup></label>
                            <input class="form__control" id="tracking_number" name="tracking_number" type="text"
                                   :placeholder="get_translation_constant('text_10_to_24_characters')"
                                   minlength="10" maxlength="24"
                                   v-model="new_order.track_code"
                                   :disabled=" (parcel !==null) && (parcel.parcel_tracking_status_id ===2)">
                            <div class="form__error" v-if="hasErrorMessage('track_code')">
                                {{ hasErrorMessage('track_code') }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-5">
                        <div class="form__col" :class="hasError('market_id')">
                            <label>{{ get_translation_constant('text_shop') }}<sup>*</sup></label>
                            <div class="autocomplete">
                                <input class="form__control" id="shop" @focus="clearShopData()" type="text" name="shop"
                                       v-model="search" :placeholder="get_translation_constant('text_start_typing')"
                                       autocomplete="off"
                                       :disabled=" (parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared">
                                <ul id="results" :class="getShopResultClass">
                                    <li class="result" v-for="(shop, index) in filteredShops " @click="setShop(shop)">
                                        <span class="user_serch_name"></span>
                                        <span class="user_room">
                                          <template
                                              v-for="(name, index) in shop.title.toLowerCase().split(search.toLowerCase())">
                                              <template
                                                  v-if="(shop.title.toLowerCase().split(search.toLowerCase()).length ===1) "><span
                                                  class="highlight">{{ search.toLowerCase() }}</span>{{
                                                      name
                                                  }}</template>
                                              <template
                                                  v-else-if="(index !== (shop.title.toLowerCase().split(search.toLowerCase()).length -1)) && (shop.title.toLowerCase().split(search.toLowerCase()).length >1) ">{{
                                                      name
                                                  }}<span class="highlight">{{ search.toLowerCase() }}</span></template>
                                              <template v-else>{{ name }}</template>
                                        </template>
                                        </span>
                                    </li>
                                </ul>
                                <div class="form__error" v-if="hasErrorMessage('market_id')">
                                    {{ get_translation_constant('text_field_is_required') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form__col" :class="hasError('market_category_id')">
                            <label>{{ get_translation_constant('text_product_category') }}<sup>*</sup></label>
                            <multiselect class="selectpicker" v-model="new_order.category"
                                         :multiple="false"
                                         :placeholder="get_translation_constant('text_choose_category')"
                                         :options="filteredCategories"
                                         label="title"
                                         selectLabel=""
                                         deselectLabel=""
                                         :optionHeight="48"
                                         :showPointer="true"
                                         :disabled=" (parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_choose_category') : option.title
                                        }}</span>
                                </template>
                            </multiselect>
                            <div class="form__error" v-if="hasErrorMessage('market_category_id')">
                                {{ get_translation_constant('text_field_is_required') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product__item_template">
                    <div class="product__item">
                        <div class="row small-gutters">
                            <div class="col-12 col-md-5 col-lg-5 product__item_col_name">
                                <div class="form__col">
                                    <label>{{ get_translation_constant('text_product') }}</label>
                                    <input class="form__control" id="product_name" name="" type="text"
                                           :placeholder="get_translation_constant('text_product_name')"
                                           v-model="new_order.products[0].name"
                                           @keyup.enter.prevent="enterHandle()"
                                           @keydown.enter.prevent="enterHandle()"
                                           :disabled=" (parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                    >
                                    <div class="form__error" style="display:block; color: red"
                                         v-if="hasErrorMessage('products.0.name')">
                                        {{ hasErrorMessage('products.0.name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto col-md-3 col-lg-3  product__item_col_quantity col-custom-1">
                                <div class="form__col ">
                                    <label>{{ get_translation_constant('text_qty') }}</label>
                                    <div class="block__input_quantity">
                                        <button class="js-minus" @click.prevent="decrementExampleQty"></button>
                                        <input class="form__control input_quantity" id="product_quantity_" name=""
                                               type="number" v-model="new_order.products[0].qty"
                                               @input="controlQtyExample"
                                               @keyup.enter.prevent="enterHandle()"
                                               @keydown.enter.prevent="enterHandle()"
                                               :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                        >
                                        <button class="js-plus" @click.prevent="incrementExampleQty"></button>
                                    </div>
                                    <div class="form__error" style="display:block; color: red"
                                         v-if="hasErrorMessage('products.0.qty')">
                                        {{ hasErrorMessage('products.0.qty') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto col-md-3 col-lg-3 product__item_col_price col-custom-2">
                                <div class="form__col">
                                    <label>{{ get_translation_constant('text_price') }}</label>
                                    <div class="product__item_price_block">
                                        <input class="form__control " id="product_price" name="" type="number"
                                               :placeholder="get_translation_constant('text_product_name')"
                                               v-model="new_order.products[0].price"
                                               @input="controlInputExamplePrice"
                                               @keyup.enter.prevent="enterHandle()"
                                               @keydown.enter.prevent="enterHandle()"
                                               :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                        >
                                        <multiselect class="selectpicker" v-model="new_order.products[0].currency"
                                                     :multiple="false"
                                                     :placeholder="''"
                                                     :options="currencyList"
                                                     label="symbol"
                                                     selectLabel=""
                                                     deselectLabel=""
                                                     :optionHeight="48"
                                                     :showPointer="true"
                                                     :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                        >
                                            <template></template>
                                        </multiselect>
                                    </div>
                                    <div class="form__error" style="display:block; color: red"
                                         v-if="hasErrorMessage('products.0.price')">
                                        {{ hasErrorMessage('products.0.price') }}
                                    </div>
                                    <div class="form__error" style="display:block; color: red"
                                         v-if="hasErrorMessage('products.0.currency')">
                                        {{ hasErrorMessage('products.0.currency') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto col-md-1 col-lg-1 col-custom-3">
                                <div class="product__item_action">
                                    <button class="product__item_add"
                                            :title="get_translation_constant('text_add_product')"
                                            @click.prevent="addProduct()">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 21.6c5.24 0 9.6-4.35 9.6-9.6 0-5.24-4.37-9.6-9.61-9.6A9.66 9.66 0 002.4 12c0 5.25 4.35 9.6 9.6 9.6zm0-1.6c-4.44 0-8-3.56-8-8a8 8 0 118 8zm-.03-3.53c.51 0 .81-.35.81-.9V12.8h2.95c.52 0 .9-.27.9-.77s-.36-.8-.9-.8h-2.95V8.26c0-.55-.3-.9-.8-.9s-.78.37-.78.9v2.96H8.26c-.55 0-.9.3-.9.8s.38.77.9.77h2.94v2.79c0 .52.27.9.77.9z"
                                                fill="#00A5FF"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="products_list">
                    <template v-for="(product, index) in productList">
                        <div class="product__item" v-if="!!(new_order.products.length - index-1)">
                            <div class="row small-gutters">
                                <div class="col-12 col-md-5 col-lg-5">
                                    <div class="form__col" :class="hasError('products.'+(index+1)+'.name')">
                                        <label :for="'product_name_1'+index">{{
                                                get_translation_constant('text_product')
                                            }}
                                            {{ new_order.products.length - index }}<sup>*</sup></label>
                                        <input class="form__control" :id="'product_name_1'+index"
                                               :name="'product'+index"
                                               type="text" :placeholder="get_translation_constant('text_product_name')"
                                               v-model="new_order.products[new_order.products.length - index-1].name"
                                               @keyup.enter.prevent="enterHandle()"
                                               @keydown.enter.prevent="enterHandle()"
                                               :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                        >
                                        <div class="form__error" v-if="hasErrorMessage('products.'+(new_order.products.length - index-1)+'.name')">
                                            {{ get_translation_constant('text_field_is_required') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto col-md-3 col-lg-3 col-custom-1">
                                    <div class="form__col" :class="hasError('products.'+(new_order.products.length - index-1)+'.qty')">
                                        <label :for="'product_qty_1'+index">{{
                                                get_translation_constant('text_qty')
                                            }}<sup>*</sup></label>
                                        <div class="block__input_quantity">
                                            <button class="js-minus"
                                                    @click.prevent="decrementQty(new_order.products.length - index-1)"></button>
                                            <input class="form__control input_quantity type_tel"
                                                   :id="'product_qty_1'+index"
                                                   :name="'product_qty'+index" type="number"
                                                   v-model="new_order.products[new_order.products.length - index-1].qty"
                                                   @input="controlQty(new_order.products.length - index-1)"
                                                   @keyup.enter.prevent="enterHandle()"
                                                   @keydown.enter.prevent="enterHandle()"
                                                   :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                            >
                                            <button class="js-plus"
                                                    @click.prevent="incrementQty(new_order.products.length - index-1)"></button>
                                        </div>
                                        <div class="form__error" v-if="hasErrorMessage('products.'+(new_order.products.length - index-1)+'.qty')">
                                            {{ get_translation_constant('text_field_is_required') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto col-md-3 col-lg-3 col-custom-2">
                                    <div class="form__col" :class="hasError('products.'+(new_order.products.length - index-1)+'.price')">
                                        <label :for="'product_price'+index">{{
                                                get_translation_constant('text_price')
                                            }}<sup>*</sup></label>
                                        <div class="product__item_price_block">
                                            <input class="form__control type_tel" :id="'product_price'+index"
                                                   :name="'product_price'+index" placeholder="0"
                                                   v-model="new_order.products[new_order.products.length - index-1].price"
                                                   @input="controlInput($event.target.value,new_order.products.length - index-1)"
                                                   @keyup.enter.prevent="enterHandle()"
                                                   @keydown.enter.prevent="enterHandle()"
                                                   :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"
                                                   type="number">
                                            <multiselect class="selectpicker"
                                                         v-model="new_order.products[new_order.products.length - index-1].currency"
                                                         :multiple="false"
                                                         :placeholder="''"
                                                         :options="currencyList"
                                                         label="symbol"
                                                         selectLabel=""
                                                         deselectLabel=""
                                                         :optionHeight="48"
                                                         :showPointer="true"
                                                         :searchable="false"
                                                         :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"

                                            >
                                                <template></template>
                                            </multiselect>
                                        </div>
                                        <div class="form__error" v-if="hasErrorMessage('products.'+(new_order.products.length - index-1)+'.price')">
                                            {{ get_translation_constant('text_field_is_required') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto col-md-1 col-lg-1 col-custom-3">
                                    <div class="product__item_action">
                                        <button class="product__item_remove"
                                                :title="get_translation_constant('text_remove_product')"
                                                @click.prevent="removeProduct(product)">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M17.2 18.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V5.7c0-1.02-.72-1.69-1.86-1.69h-2.76c-1.14 0-1.84.67-1.84 1.69v1.07H5.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM9.96 5.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM8.73 18.93a.75.75 0 01-.77-.73L7.44 7.84h9.1l-.5 10.36a.74.74 0 01-.76.73H8.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V9.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                                    fill="#76777C"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="form__col d-flex justify-content-lg-end">
                    <div class="packages__total_price">
                        {{ get_translation_constant('text_total_products_price') }}: <span>{{
                            getFinalPrice.total
                        }}</span> {{ getFinalPrice.symbol }}
                    </div>
                </div>
                <div class="extra__services">

                    <h4 class="h_text_small with__line"><span>{{ get_translation_constant('text_additional_services') }} +</span>
                    </h4>
                    <!-- add 0  - remove split -->
                    <div class="new-order-main" :class="{'has-splits':splits.length && checkedSplit && false}">
                        <div class="new-order-main-code"><a href="">{{
                                new_order.track_code.length ? new_order.track_code : get_translation_constant('text_need_track_number')
                            }}</a></div>
                        <div class="row ">
                            <template v-for="(chunkServices, index) in sliceIntoChunks(services, 3)">
                                <div v-for="(service, chunk_index) in chunkServices" class="col-12 col-md-6 col-lg-5">
                                    <div class="checkbox__custom">
                                        <input :id="'checkbox'+( index * 3 + chunk_index)"
                                               :name="'checkbox'+( index * 3 + chunk_index)" type="checkbox"
                                               v-model="new_order.services[index * 3 + chunk_index].checked"
                                               :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"

                                        >
                                        <label :for="'checkbox'+( index * 3 + chunk_index)">
                                    <span class="tooltip__block tooltip__right tooltip__modal">
                                        <span class="tooltip__block_trigger">
                                            <img :src="service.icon" alt="" class="service-image">
                                            {{ service.title }}
                                            <span v-if="!!service.value">+ {{ service.value }}
                                                        <template v-if="service.as_a_percentage">%</template>
                                                        <template v-else>{{ getCurrencySymbol(service) }}</template>
                                            </span>
                                            <span v-else>{{ get_translation_constant('text_free') }}</span>
                                        </span>
                                        <span class="tooltip__block_overlay">
                                            <span class="tooltip__block_inner">
                                                                <span class="tooltip__block_close"></span>
                                                                <p>{{ service.description }}</p>
                                                                <p><a
                                                                    :href="service.link">{{
                                                                        get_translation_constant('text_learn_more_about_insurance')
                                                                    }}</a></p>
                                                            </span>
                                        </span>
                                    </span>
                                        </label>
                                    </div>
                                </div>
                            </template>
                            <template v-for="(chunkSolutions, index) in sliceIntoChunks(solutions, 3)">
                                <div v-for="(solution, chunk_index) in chunkSolutions"
                                     class="col-12 col-md-6 col-lg-5 df">
                                    <div class="checkbox__custom">
                                        <input :id="'checkbox_solution'+( index * 3 + chunk_index)"
                                               :name="'checkbox_solution'+( index * 3 + chunk_index)" type="checkbox"
                                               v-model="new_order.solutions[index * 3 + chunk_index].checked"
                                               :disabled="(solution.solution_id === 1) && (!!(newProductsCnt<2) || (parcel !== null))"
                                        >
                                        <label :for="'checkbox_solution'+( index * 3 + chunk_index)">
                                    <span class="tooltip__block tooltip__right tooltip__modal">
                                        <span class="tooltip__block_trigger">
                                            <img :src="solution.icon" alt="" class="service-image">
                                            {{ solution.title }}
                                            <span v-if="solution.as_percentage">
                                                {{ solution.value }} %
                                            </span>
                                            <template v-else>
                                            <span v-if="!!solution.tariff">+ {{ solution.tariff }} {{
                                                    getCurrencySymbol(solution)
                                                }}</span>
                                            <span v-else>{{ get_translation_constant('text_free') }}</span>
                                            </template>
                                        </span>
                                        <span class="tooltip__block_overlay">
                                            <span class="tooltip__block_inner">
                                                                <span class="tooltip__block_close"></span>
                                                                <p>{{ solution.description }}</p>
                                                                <p><a
                                                                    :href="solution.link">{{
                                                                        solution.link_info
                                                                    }}</a></p>
                                                            </span>
                                        </span>
                                    </span>
                                        </label>
                                    </div>
                                    <div
                                        v-if="(solution.solution_id === 1) && solution.checked && newProductsCnt>1"
                                        class="product__item_col_quantity"
                                        :class="(services.length+chunk_index) % 2 === 0 ? 'split-even':'split-odd'"
                                    >
                                        <div class="form__col " :class="hasError('split_count')">
                                            <div class="block__input_quantity">
                                                <span class="js-minus" @click.prevent="decrementSplitQty"></span>
                                                <input class="form__control input_quantity" id="splitCnt" name=""
                                                       type="number" :min="2" :step="1"
                                                       :max="newProductsCnt"
                                                       v-model="new_order.split_count"
                                                       @input="controlInputSplit($event.target.value)"
                                                       @change="controlInputSplitQty($event.target.value, newProductsCnt)"
                                                       @keyup.enter.prevent="enterHandle()"
                                                       @keydown.enter.prevent="enterHandle()"
                                                       :disabled="(parcel !==null) && (parcel.parcel_tracking_status_id ===2)  && !!localParcel.declared"

                                                >
                                                <span class="js-plus" @click.prevent="incrementSplitQty"></span>
                                            </div>
                                            <div class="form__error" v-if="hasErrorMessage('split_count')">
                                                {{ hasErrorMessage('split_count') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- add 0 - remove split-->
                    <div class="row splits" v-if="splits.length && checkedSplit && false">
                        <template v-for="(split, splitIndex) in splits">
                            <div class="new-order-split-item">
                                <div class="new-order-split-item-code"><a
                                    onclick="void(0)"
                                    href="">{{ new_order.track_code + '-' + (splitIndex + 1) }}</a></div>

                                <div class="row">
                                    <template v-for="(chunkSplitServices, index) in sliceIntoChunks(splitServices, 3)">
                                        <div v-for="(splitService, chunk_split_index) in chunkSplitServices"
                                             class="col-12 col-md-6 col-lg-5">
                                            <div class="checkbox__custom">
                                                <input
                                                    :id="'split-service-checkbox'+splitIndex+ index * 3 + chunk_split_index"
                                                    :name="'split-service-checkbox'+splitIndex+ index * 3 + chunk_split_index"
                                                    type="checkbox"
                                                    v-model="splits[splitIndex]['services'][index * 3 + chunk_split_index].checked">
                                                <label
                                                    :for="'split-service-checkbox'+splitIndex+ index * 3 + chunk_split_index">
                                    <span class="tooltip__block tooltip__right tooltip__modal">
                                        <span class="tooltip__block_trigger">
                                            <img :src="splitService.icon" alt="" class="service-image">
                                            {{ splitService.title }}
                                            <span v-if="!!splitService.value">+ {{ splitService.value }}
                                                        <template v-if="splitService.as_a_percentage">%</template>
                                                        <template v-else>{{
                                                                getCurrencySymbol(splitService)
                                                            }}</template>
                                            </span>
                                            <span v-else>{{ get_translation_constant('text_free') }}</span>
                                        </span>
                                        <span class="tooltip__block_overlay">
                                            <span class="tooltip__block_inner">
                                                                <span class="tooltip__block_close"></span>
                                                                <p>{{ splitService.description }}</p>
                                                                <p><a
                                                                    :href="splitService.link">{{
                                                                        get_translation_constant('text_learn_more_about_insurance')
                                                                    }}</a></p>
                                                            </span>
                                        </span>
                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                    <template
                                        v-for="(chunkSplitSolutions, index) in sliceIntoChunks(splitSolutions, 3)">
                                        <div v-for="(splitSolution, chunk_index) in chunkSplitSolutions"
                                             class="col-12 col-md-6 col-lg-5">
                                            <div class="checkbox__custom">
                                                <input
                                                    :id="'splits-checkbox_solution'+splitIndex+index * 3 + chunk_index"
                                                    :name="'splits-checkbox_solution'+ splitIndex+index * 3 + chunk_index"
                                                    type="checkbox"
                                                    v-model="splits[splitIndex]['solutions'][index * 3 + chunk_index].checked"
                                                >
                                                <label
                                                    :for="'splits-checkbox_solution'+splitIndex+index * 3 + chunk_index">
                                    <span class="tooltip__block tooltip__right tooltip__modal">
                                        <span class="tooltip__block_trigger">
                                            <img :src="splitSolution.icon" alt="" class="service-image">
                                             {{ splitSolution.title }}
                                            <template v-if="splitSolution.as_percentage">
                                                {{ splitSolution.value }} %
                                            </template>
                                            <template v-else>
                                            <span v-if="!!splitSolution.tariff">+ {{ splitSolution.tariff }} {{
                                                    getCurrencySymbol(splitSolution)
                                                }}</span>
                                            <span v-else>{{ get_translation_constant('text_free') }}</span>
                                            </template>
                                        </span>
                                        <span class="tooltip__block_overlay">
                                            <span class="tooltip__block_inner">
                                                                <span class="tooltip__block_close"></span>
                                                                <p>{{ splitSolution.description }}</p>
                                                                <p><a
                                                                    :href="splitSolution.link">{{
                                                                        splitSolution.link_info
                                                                    }}</a></p>
                                                            </span>
                                        </span>
                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </template>

                                </div>

                            </div>

                        </template>
                    </div>
                </div>
                <div class="form__col">
                    <label for="comments">{{ get_translation_constant('text_comment') }}</label>
                    <textarea
                        v-model="new_order.comment"
                        class="form__control"
                        name="comments"
                        id="comments"
                        :placeholder="get_translation_constant('text_comment')">
                    </textarea>
                </div>
                <!--                <div class="form__col form__col_promo_code" :class="hasError('promo_code')">
                                    <label for="promo_code">{{ get_translation_constant('text_promo_code') }}</label>
                                    <input
                                        v-model="new_order.promo_code.code"
                                        class="form__control"
                                        name="promo_code"
                                        id="promo_code"
                                        :readonly="hasPromoCode"
                                        :placeholder="get_translation_constant('text_promo_code_placeholder')"
                                    >
                                    <div class="form__success" v-if="isValidPromo" v-html="getPromoCodeText">
                                    </div>
                                    <div class="form__error" v-if="hasErrorMessage('promo_code')">
                                        {{ hasErrorMessage('promo_code') }}
                                    </div>
                                    <a class="btn"
                                       @click.prevent="checkPromoCode">{{ get_translation_constant('text_apply') }}</a>
                                </div>-->
                <div class="row align-items-end">
                    <div class="col-12 col-md-6">
                        <div class="form__col mb-md-0">
                            <label>{{ get_translation_constant('text_delivery_through_agent') }}<span
                                class="tooltip__block tooltip__bottom tooltip__modal">
                                    <span class="tooltip__block_trigger">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                                fill="#515154"/>
                                        </svg>
                                    </span>
                                    <span class="tooltip__block_overlay">
                                        <span class="tooltip__block_inner">
                                            <span class="tooltip__block_close"></span>
                                            <p>{{ get_translation_constant('agent_info') }}</p>
                                            <!--                                        <p><a
                                                                                        :href="agentinfo.link"> {{
                                                                                            get_translation_constant('text_learn_more_about_agents')
                                                                                        }} </a></p>-->
                                    </span>
                                    </span>
                                </span>
                            </label>
                            <multiselect class="selectpicker" v-model="new_order.agent"
                                         :multiple="false"
                                         :placeholder="get_translation_constant('text_delivery_through_agent')"
                                         :options="agentList"
                                         label="name"
                                         selectLabel=""
                                         deselectLabel=""
                                         :optionHeight="48"
                                         :showPointer="true"
                                         :searchable="false"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <a class="btn btn__medium btn__block btn__blue"
                           @click.prevent="saveOrder()" :disabled="sendRequestFlag">{{ get_translation_constant('text_declaration') }}</a>
                    </div>
                </div>

            </form>
        </div>
        <div class="simple__block" v-show="orders_list.length >0">
            <h3 class="h5">{{ get_translation_constant('text_new_order_list') }}</h3>
            <table class="table table__new__orders">
                <thead>
                <tr>
                    <th>{{ get_translation_constant('text_tracking_number') }}</th>
                    <th>{{ get_translation_constant('text_additional_services') }}</th>
                    <th>{{ get_translation_constant('text_date') }}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="(order, index) in orders_list">
                    <td><a :href="order.view_link">{{ order.track_code }}</a></td>
                    <td>
                        <div
                            class="table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center">

                            <span v-for="(service, service_index) in order.services"
                                  class="tooltip__block tooltip__top tooltip__block_simple">
                              <span class="tooltip__block_trigger">
                                                        <img :src="service.icon" alt="" class="service-image">
                                                    </span>
                              <span class="tooltip__block_inner">
                                                        <p>{{ service.title }}</p>
                                                    </span>
                            </span>
                        </div>
                    </td>
                    <td style="white-space: nowrap">{{ order.date }}</td>
                    <td>
                        <div class="table__actions d-flex justify-content-end">
                            <a :href="order.edit_link" :title="get_translation_constant('text_edit_product')">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M17.25 3.87l.55-.59c.27-.27.27-.66 0-.92l-.17-.2c-.23-.24-.6-.2-.85.05l-.56.57 1.03 1.1zm-8.72 8.24l1.48-.68 6.7-6.98-1.05-1.07-6.69 6.99-.68 1.48c-.06.14.1.32.24.26zM5.38 18h8.9c1.37 0 2.16-.82 2.16-2.46V6.73L15.2 8.01v7.47c0 .83-.42 1.24-.94 1.24H5.4c-.75 0-1.18-.41-1.18-1.24V6.5c0-.82.43-1.25 1.18-1.25h6.56l1.22-1.27h-7.8C3.8 3.97 3 4.79 3 6.42v9.12C3 17.18 3.8 18 5.38 18z"
                                        fill="#06C"/>
                                </svg>
                            </a>
                            <a href="#" @click.prevent="removeOrder(order)"
                               :title="get_translation_constant('text_remove_product')">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                        fill="#515154"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
        <alert-modal :modalId="modalId" :title="modalTitle" :type="modalType" :message="modalMessage"></alert-modal>
    </div>
</template>

<script>
export default {
    name: "NewOrder",
    props: {
        translations: {
            type: [Object, Array]
        },
        orders: {
            type: [Object, Array]
        },
        shops: {
            type: [Object, Array]
        },
        services: {
            type: [Object, Array]
        },
        currencies: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        categorysearchurl: {
            type: [String]
        },
        shopssearchurl: {
            type: [String]
        },
        agents: {
            type: [Object, Array]
        },
        agentinfo: {
            type: [Object, Array]
        },
        createorderlink: {
            type: [String]
        },
        updateorderlink: {
            type: [String]
        },
        parcel: {
            type: [Object],
            default: null
        },
        promocodecheckurl: {
            type: [String]
        },
        solutions: {
            type: [Object, Array],
            default: null
        },
        marketcategories: {
            type: [Object, Array],
            default: null
        },
        nodeid: {
            type: [Number, String]
        }
    },
    data() {
        return {
            errors: [],
            alert: '',
            orders_list: [],
            new_order: {
                track_code: '',
                shop: {
                    id: '',
                    name: ''
                },
                category: {
                    id: '',
                    name: ''
                },
                products: [],
                services: [],
                solutions: [],
                agent: {
                    id: '',
                    name: ''
                },
                files: [],
                comment: '',
                promo_code: {
                    code: '',
                    text: ''
                },
                split_count: 2,
                splits: []
            },
            search: '',
            shop_selected: false,
            search_category: '',
            category_list: [],
            isLoading: false,
            example_product: {
                name: '',
                price: 0,
                currency: {
                    id: 1,
                    symbol: '$'
                },
                qty: 1
            },
            files: [],
            newOrdersList: [],
            modal: {
                type: 'success',
                title: '',
                message: '',
                id: 'New'
            },
            localParcel: null,
            isValidPromo: false,
            splits: [],
            splitSolutions: [],
            splitServices: [],
            sendRequestFlag:false
        }
    },
    methods: {
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },
        hasErrorMessage(error) {
            if (this.errors[error])
                return this.errors[error][0];
        },
        clearError(error) {
            if (this.errors[error])
                delete this.errors[error];
        },
        removeOrder(order) {
            if (confirm(this.get_translation_constant('text_confirm_delete_parcel'))) {
                axios.post(order.delete_link, {order_id: order.id, ajax: true}).then(response => {
                    if (response.status === 200) {
                        this.orders_list.splice(this.orders_list.indexOf(order), 1);
                        let orderCnt = this.orders_list.length.toString();
                        document.getElementById('headerBottomNew').innerText = orderCnt;
                        document.getElementById('headerBottomNewMobile').innerText = orderCnt;
                        this.modal.title = 'Success delete order';
                        this.modal.type = 'success';
                        this.modal.message = 'Success delete order'
                        document.getElementById('AlertModalBtn' + this.modal.id).click()
                        this.alert = this.get_translation_constant('success_delete_order');
                    }
                }).catch(error => {
                    if (error.response.status === 400) {
                        this.alert = this.get_translation_constant('error_delete_order');
                    }
                    if (error.response.status === 422) {
                        this.alert = this.get_translation_constant('error_delete_order');
                    }
                    if (error.response.status === 500) {
                        this.alert = this.get_translation_constant('error_delete_order');
                    }
                });
            }
        },
        clearNewOrder() {
            this.new_order.track_code = '';
            this.new_order.shop = {id: '', name: ''};
            this.new_order.category = {id: '', name: ''};
            this.new_order.products = [];
            this.new_order.agent = {id: '', name: ''};
            this.new_order.files = [];
            this.search = '';
            this.shop_selected = false;
            this.search_category = '';
            this.new_order.products[0] = this.example_product;
            this.files = [];
            this.new_order.services.map((item) => {
                item.checked = false
            })
            this.new_order.solutions.map((item) => {
                item.checked = false
            })
        },
        saveOrder() {
            let marketId = '';

            if ((typeof this.new_order.shop !== 'undefined') && (this.new_order.shop.id !== '')) {
                marketId = this.new_order.shop.id;
            } else {
                marketId = this.search;
            }


            if (this.localParcel !== null) {


                let order = {
                    id: this.parcel.id,
                    track_code: this.new_order.track_code,
                    market_id: marketId,
                    market_category_id: this.new_order.category?.id,
                    products: this.new_order.products,
                    services: this.new_order.services,
                    solutions: this.new_order.solutions,
                    user_agent_id: this.new_order.agent?.id,
                    comment: this.new_order.comment,
                    promo_code: this.new_order.promo_code.code,
                    split_count: this.new_order.split_count,
                    splits: this.splits
                }
                order.services = order.services.filter((item) => {
                    return item['checked'] === true
                }).map((service) => {
                    return service.id
                });

                order.solutions = order.solutions.filter((item) => {
                    return item['checked'] === true
                }).map((solution) => {
                    return {
                        id: solution.id,
                        solution_id: solution.solution_id
                    }
                });
                this.sendRequestFlag = true;
                axios.post(this.updateorderlink, order).then(response => {
                    if (response.status === 200) {
                        this.errors = []
                        //       this.orders_list.find((item) => item.id === order.id).services = order.services;
                        this.modal.title = this.get_translation_constant('text_success_update_product_title');
                        this.modal.type = 'success';
                        this.modal.message = this.get_translation_constant('text_success_update_product_message');
                        this.localParcel.declared = true;
                        document.getElementById('AlertModalBtn' + this.modal.id).click()
                        this.sendRequestFlag = false;
                    }
                }).catch(error => {
                    if (error.response.status === 400) {
                        this.errors = error.response.data.errors;
                        this.sendRequestFlag = false;
                    }
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.sendRequestFlag = false;
                    }
                    if (error.response.status === 500) {
                        this.modal.title = this.get_translation_constant('error_title');
                        this.modal.type = 'error';
                        this.modal.message = this.get_translation_constant('parcel_not_found_error_message');
                        document.getElementById('AlertModalBtn' + this.modal.id).click()
                        this.sendRequestFlag = false;
                    }
                });
                return false;
            }

            let new_order = {
                track_code: this.new_order.track_code,
                market_id: marketId,
                market_category_id: this.new_order.category?.id,
                products: this.new_order.products,
                services: this.new_order.services,
                solutions: this.new_order.solutions,
                user_agent_id: this.new_order.agent?.id,
                comment: this.new_order.comment,
                promo_code: this.new_order.promo_code.code,
                split_count: this.new_order.split_count,
                splits: this.splits
            }
            new_order.services = new_order.services.filter((item) => {
                return item['checked'] === true
            }).map((service) => {
                return service.id
            });

            new_order.solutions = new_order.solutions.filter((item) => {
                return item['checked'] === true
            }).map((solution) => {
                return {
                    id: solution.id,
                    solution_id: solution.solution_id
                }
            });
            this.sendRequestFlag = true;
            axios.post(this.createorderlink, new_order).then(response => {
                if (response.status === 200) {
                    let new_order = {
                        id: response.data.order.id,
                        track_code: response.data.order.track_code,
                        date: response.data.order.date,
                        services: response.data.order.services,
                        solutions: response.data.order.solutions,
                        view_link: response.data.order.view_link,
                        delete_link: response.data.order.delete_link,
                        edit_link: response.data.order.edit_link,
                    }
                    this.orders_list.push(new_order);
                    this.clearNewOrder();
                    this.modal.title = this.get_translation_constant('text_success_add_product_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_add_product_message');
                    this.errors = [];
                    this.new_order.promo_code = {
                        code: '',
                        text: ''
                    };
                    this.splits = [];
                    this.splits.push({
                        services: this.getSplitServices(),
                        solutions: this.getSplitSolutions()
                    })
                    this.new_order.split_count = 2;
                    let orderCnt = this.orders_list.length.toString();
                    document.getElementById('headerBottomNew').innerText = orderCnt;
                    document.getElementById('headerBottomNewMobile').innerText = orderCnt;
                    document.getElementById('AlertModalBtn' + this.modal.id).click()
                    this.sendRequestFlag = false;
                }
            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                    this.sendRequestFlag = false;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.sendRequestFlag = false;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;
                    this.sendRequestFlag = false;
                }
            });

        },
        getCurrencySymbol(service) {
            return '$';
        },
        sliceIntoChunks(arr, chunkSize) {
            const res = [];
            for (let i = 0; i < arr.length; i += chunkSize) {
                const chunk = arr.slice(i, i + chunkSize);
                res.push(chunk);
            }
            return res;
        },
        controlInput(val, index) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if ((this.new_order.products[index].price.length > 1) && (this.new_order.products[index].price[0] === '0')) {
                this.new_order.products[index].price = this.new_order.products[index].price.slice(1);
            }
            if (this.new_order.products[index].price < 0) {
                this.new_order.products[index].price = 0;
            }

            if (this.new_order.products[index].price > 9999) {
                this.new_order.products[index].price = 9999
            }
        },
        controlInputExamplePrice() {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if ((this.new_order.products[0].price.length > 1) && (this.new_order.products[0].price[0] === '0')) {
                this.new_order.products[0].price = this.new_order.products[0].price.slice(1);
            }
            if (isNaN(this.new_order.products[0].price)) {
                this.new_order.products[0].price = 0;
            }
            if (this.new_order.products[0].price < 0) {
                this.new_order.products[0].price = 0;
            }
            if (this.new_order.products[0].price > 9999) {
                this.new_order.products[0].price = 9999
            }
        },
        controlInputExample(val) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if (isNaN(this.new_order.products[0].price)) {
                this.new_order.products[0].price = 0;
            }
            if (this.new_order.products[0].price < 0) {
                this.new_order.products[0].price = 0;
            }
            if (!isNaN(parseFloat(val)) && !isNaN(Number(val))) {
                this.new_order.products[0].price = Number(val).toFixed(2)
            } else {
                this.new_order.products[0].price = 0;
            }
            if (this.new_order.products[0].price > 9999) {
                this.new_order.products[0].price = 9999
            }
        },
        controlInputSplitQty(val, max) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)) {
                return
            }
            if (parseInt(this.new_order.split_count) == '1') {
                this.new_order.split_count = 2
            }
        },
        controlInputSplit(val) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)) {
                return
            }
            let initialValue = 0;
            let productCnt = this.new_order.products.reduce(
                (accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue.qty),
                initialValue
            );


            if (parseInt(productCnt) > 999) {
                productCnt = 999;
            }
            if ((this.new_order.split_count.length > 1) && (this.new_order.split_count[0] === '0')) {

                this.new_order.split_count = this.new_order.split_count.slice(1)
            }
            if (!isNaN(parseFloat(this.new_order.split_count)) && !isNaN(Number(this.new_order.split_count))) {

                if (parseInt(this.new_order.split_count) > parseInt(productCnt)) {
                    this.new_order.split_count = parseInt(productCnt);
                    return;
                }
                if (parseInt(productCnt) < 10 && (this.new_order.split_count == '1')) {
                    this.new_order.split_count = 2
                } else {
                    this.new_order.split_count = parseInt(val);
                }

            } else {
                this.new_order.split_count = 2;
            }
        },
        controlQty(index) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if ((this.new_order.products[index].qty.length > 1) && (this.new_order.products[index].qty[0] === '0')) {
                this.new_order.products[index].qty = this.new_order.products[index].qty.slice(1);
            }
            if (this.new_order.products[index].qty < 1) {
                this.new_order.products[index].qty = 1;
            }
            if (this.new_order.products[index].qty > 999) {
                this.new_order.products[index].qty = 999;
            }
        },
        incrementQty(index) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }            this.new_order.products[index].qty++;
        },
        decrementQty(index) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if (this.new_order.products[index].qty > 1) {
                this.new_order.products[index].qty--;
            }

        },
        incrementExampleQty() {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            this.new_order.products[0].qty++;
        },
        decrementExampleQty() {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if (this.new_order.products[0].qty > 1) {
                this.new_order.products[0].qty--;
            }

        },
        controlQtyExample() {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return
            }
            if ((this.new_order.products[0].qty.length > 1) && (this.new_order.products[0].qty[0] === '0')) {
                this.new_order.products[0].qty = this.new_order.products[0].qty.slice(1);
            }
            if (this.new_order.products[0].qty <= 0) {
                this.new_order.products[0].qty = 0;
            }
            if (this.new_order.products[0].qty > 999) {
                this.new_order.products[0].qty = 999
            }
        },
        incrementSplitQty() {

            let initialValue = 0;
            let productCnt = this.new_order.products.reduce(
                (accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue.qty),
                initialValue
            );

            if (productCnt <= this.new_order.split_count) {
                return;
            }
            this.new_order.split_count++;

            if (this.new_order.split_count > 999) {
                this.new_order.split_count = 999
            }
        },
        decrementSplitQty() {
            if (this.new_order.split_count > 2) {
                this.new_order.split_count--;
            }
        },
        addProduct() {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return;
            }
            const product = {
                name: '',
                price: 0,
                currency: this.new_order.products[0].currency,
                qty: 1,
            };

            this.new_order.products.push(product)
        },
        removeProduct(product) {
            if ((this.parcel !== null) && (this.parcel.parcel_tracking_status_id === 2)  && !!this.localParcel.declared) {
                return;
            }
            this.new_order.products.splice(this.new_order.products.indexOf(product), 1);
        },
        clearShopData() {
            this.search = '';
            this.shop_selected = false;
            this.new_order.shop = {
                id: '',
                name: ''
            }
        },
        clearCategoryList() {
            this.category_list = [];
        },
        asyncFind(query) {
            //clear selection model
            this.search_category = query;
            this.isLoading = true
            axios.post(this.categorysearchurl, {search: this.search_category, locale: this.lng}).then(response => {

                if (response.status === 200) {
                    this.category_list = response.data.categories;
                    this.isLoading = false
                }
                this.isLoading = false;

            }).catch(error => {

                if (error.response.status === 422) {
                    this.alert = error.response.data.errors;
                    this.category_list = [];
                    this.isLoading = false
                }
                if (error.response.status === 500) {
                    this.alert = error.response.data.errors;
                    this.category_list = [];
                    this.isLoading = false
                }

            });


        },
        limitText(count) {
            return `and ${count} other shops`
        },
        setShop(shop) {
            this.new_order.shop = shop;
            this.search = shop.title;
            this.shop_selected = true;
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]?.value[this.lng]
        },
        checkPromoCode() {
            if (this.new_order.promo_code.code === '') {
                this.errors = {
                    promo_code: [this.get_translation_constant('text_field_is_required')]
                }
                return false;
            }

            axios.post(this.promocodecheckurl, {promo_code: this.new_order.promo_code.code}).then(response => {
                if (response.status === 200) {
                    this.isValidPromo = true;
                    this.new_order.promo_code.text = response.data.message;
                    delete this.errors.promo_code;
                }
            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = {
                        promo_code: [this.get_translation_constant('text_promo_code_fails')]
                        //promo_code: [error.response.data.errors.message]
                    }
                    this.isValidPromo = false;
                }

                if (error.response.status === 422) {
                    this.errors = {
                        promo_code: [this.get_translation_constant('text_promo_code_fails')]
                        //  promo_code: [error.response.data.errors.message]
                    }
                    this.isValidPromo = false;
                }
                if (error.response.status === 500) {
                    this.errors = {
                        promo_code: [this.get_translation_constant('text_promo_code_fails')]
                        //promo_code: [error.response.data.errors.message]
                    }
                    this.isValidPromo = false;
                }
            });
        },
        handleSplits(operation) {
            if (operation === 'pop') {
                this.splits.pop();
            }
            if (operation === 'push') {
                this.splits.push({
                    services: this.getSplitServices(),
                    solutions: this.getSplitSolutions()
                })
            }
        },
        getSplitServices() {
            let result = [];
            for (let key in this.services) {
                result.push({
                    as_a_percentage: this.services[key].as_a_percentage,
                    checked: false,
                    description: this.services[key].description,
                    icon: this.services[key].icon,
                    id: this.services[key].id,
                    link: this.services[key].link,
                    link_info: this.services[key].link_info,
                    title: this.services[key].title,
                    value: this.services[key].value,

                })
            }

            return result;
        },
        getSplitSolutions() {
            let result = [];
            for (let key in this.solutions) {
                result.push({
                    checked: false,
                    description: this.solutions[key].description,
                    icon: this.solutions[key].icon,
                    id: this.solutions[key].id,
                    link: this.solutions[key].link,
                    link_info: this.solutions[key].link_info,
                    title: this.solutions[key].title,
                    tariff: this.solutions[key].tariff,
                    solution_id: this.solutions[key].solution_id,
                    as_percentage: this.solutions[key].as_percentage,
                    value: this.solutions[key].value
                })
            }
            return result.filter((item) => {
                return item.solution_id !== 1
            });
        },
        enterHandle() {
        }
    },
    computed: {
        getFinalPrice() {
            //TODO coeff
            let price = 0;
            this.new_order.products.map((product) => {
                if (product.currency.id === 1) {
                    price += product.price * product.qty
                }
                if (product.currency.id === 2) {
                    price += product.price * product.qty * 0.9
                }
                if (product.currency.id === 3) {
                    price += product.price * product.qty * 0.8
                }
            })
            //          price = price + this.example_product.price * this.example_product.qty
            return {
                total: price.toFixed(2),
                symbol: '$'
            }
        },
        getShopResultClass() {
            if (this.new_order.shop.id !== '') {
                return 'm-fadeOut';
            }
            if (this.shop_selected) {
                return 'm-fadeOut';
            }
            let list = [];
            if (this.search !== '') {
                list = this.shops.filter((item) => {
                    // console.log(item['name'].search(new RegExp(this.search, "i"))!== -1);
                    return ((item['title'] !== null) && item['title'].toLowerCase().indexOf(this.search?.toLowerCase()) !== -1)
                })
            }
            return list.length > 0 ? 'm-fadeIn' : 'm-fadeOut'
        },
        filteredShops() {
            let list = [];
            if (this.search !== '') {
                list = this.shops.filter((item) => {
                    // console.log(item['name'].search(new RegExp(this.search, "i"))!== -1);
                    return ((item['title'] !== null) && item['title'].toLowerCase().indexOf(this.search?.toLowerCase()) !== -1)
                })
            }
            return list;
        },
        filteredCategories() {
            return this.category_list;
        },
        modalTitle() {
            return this.modal.title
        },
        modalMessage() {
            return this.modal.message
        },
        modalType() {
            return this.modal.type
        },
        modalId() {
            return this.modal.id
        },
        hasPromoCode() {
            return (this.parcel !== null) &&
                (typeof this.parcel.promo_code !== 'undefined') &&
                (this.parcel.promo_code !== null) &&
                (this.parcel.promo_code.code !== '')

        },
        getPromoCodeText() {
            return this.get_translation_constant('text_promo_code_success') + ' ' + this.new_order.promo_code.text;
        },

        newProductsCnt() {
            let initialValue = 0;
            let productCnt = this.new_order.products.reduce(
                (accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue.qty),
                initialValue
            );
            return parseInt(productCnt);
        },
        checkedSplit() {
            let splitSolution = this.new_order.solutions.find((solution) => {
                return solution.solution_id === 1
            });
            if (typeof splitSolution === 'undefined') {
                return false
            }
            return splitSolution.checked;
        },
        currencyList() {
            if (this.nodeid == 1) {
                return this.currencies.filter((currency) => {
                    return currency.id == 1
                })
            }
            return this.currencies;
        },
        productList() {
            let list = [...this.new_order.products];
            return list.reverse();
        },
        agentList() {
            if (this.agents.length < 1) {
                return []
            }
            return this.agents.filter((agent) => !agent.is_busy).map((agent) => {
                return {
                    id: agent.id,
                    name: agent.first_name_latin + ' ' + agent.last_name_latin
                }
            })
        },
    },
    created() {
        this.orders_list = this.orders;
        this.new_order.services = this.services
        this.new_order.solutions = this.solutions
        if (this.parcel !== null) {
            this.localParcel = this.parcel;
        }
        this.category_list = this.marketcategories
        this.splitSolutions = this.getSplitSolutions();
        this.splitServices = this.getSplitServices()
        //push twice
        this.splits.push({
            services: this.getSplitServices(),
            solutions: this.getSplitSolutions()
        })
        //init new products
        this.new_order.products.push({
            name: '',
            price: 0,
            currency: {
                id: 1,
                symbol: '$'
            },
            qty: 1
        })
    },
    mounted() {

        if (this.localParcel !== null) {

            this.new_order.track_code = this.parcel.track_code;

            if (this.parcel.market !== null) {
                this.new_order.shop = this.parcel.market;
                this.search = this.parcel.market.title;
            } else {
                this.search = this.parcel.market_name;
            }
            if (this.parcel.marketCategory !== null) {
                this.new_order.category = this.parcel.marketCategory;
            }

            this.new_order.products = this.parcel.products.map(function (product) {
                let currency = {
                    id: 1,
                    symbol: '$'
                }
                if (product.currency !== null) {
                    currency.id = product.currency.id;
                    currency.symbol = product.currency.symbol;
                }
                return {
                    name: product.name,
                    price: product.price,
                    currency: currency,
                    qty: product.qty
                }
            });
            if (this.new_order.products.length === 0) {
                this.new_order.products.push({
                    name: '',
                    price: 0,
                    currency: {
                        id: 1,
                        symbol: '$'
                    },
                    qty: 1
                })
            }
            if ((this.parcel.services !== null) && (this.parcel.services.length > 0)) {
                this.new_order.services = this.new_order.services.map((service) => {
                    if (typeof this.parcel.services.find(function (item) {

                        return item.id === service.id;
                    }) !== 'undefined') {
                        service.checked = true;
                    }
                    return service;
                })
            }

            if ((this.parcel.solutions !== null) && (this.parcel.solutions.length > 0)) {
                this.new_order.solutions = this.new_order.solutions.map((solution) => {
                    if (typeof this.parcel.solutions.find(function (item) {

                        return item.id === solution.id;
                    }) !== 'undefined') {
                        solution.checked = true;
                    }
                    return solution;
                })
            }

            if (this.parcel.agent !== null) {
                this.new_order.agent = this.agents.find(agent => agent.id === this.parcel.agent.id)
            }

            /*if ((this.parcel.splits !== null) && (this.parcel.splits.length > 0)) {
                let result = []
                for (let key in this.parcel.splits) {
                    if (key === 'solutions') {
                        for (let solutionKey in this.parcel.splits['solutions']) {
                            result['solutions'].push({
                                checked: this.parcel.splits['solutions'][solutionKey].checked,
                                description: this.parcel.splits['solutions'][solutionKey].description,
                                icon: this.parcel.splits['solutions'][solutionKey].icon,
                                id: this.parcel.splits['solutions'][solutionKey].id,
                                link: this.parcel.splits['solutions'][solutionKey].link,
                                link_info: this.parcel.splits['solutions'][solutionKey].link_info,
                                title: this.parcel.splits['solutions'][solutionKey].title,
                                tariff: this.parcel.splits['solutions'][solutionKey].tariff,
                                solution_id: this.parcel.splits['solutions'][solutionKey].solution_id,
                            })
                        }
                    }
                    if (key === 'services') {
                        for (let serviceKey in this.parcel.splits['services']) {
                            result['services'].push({
                                as_a_percentage: this.parcel.splits['services'][serviceKey].as_a_percentage,
                                checked: this.parcel.splits['services'][serviceKey].checked,
                                description: this.parcel.splits['services'][serviceKey].description,
                                icon: this.parcel.splits['services'][serviceKey].icon,
                                id: this.parcel.splits['services'][serviceKey].id,
                                link: this.parcel.splits['services'][serviceKey].link,
                                link_info: this.parcel.splits['services'][serviceKey].link_info,
                                title: this.parcel.splits['services'][serviceKey].title,
                                value: this.parcel.splits['services'][serviceKey].value,
                            })
                        }
                    }
                    result.push({
                        services: result['services'],
                        solutions: result['solutions'],
                    })
                }
                this.splits = result
            }*/
        }
    },
    watch: {
        'search_category': {
            handler(val) {
            }
        },
        'new_order.promo_code.code': {
            handler(val) {
                if (val !== '') {
                    this.clearError('promo_code');
                }
            }
        },
        'new_order.split_count': {
            handler(val, oldval) {
                //handle splits
                if (parseInt(val) > parseInt(oldval)) {
                    for (let i = 0; i < val - oldval; i++) {
                        this.handleSplits('push', val);
                    }
                    return;
                }
                if (parseInt(val) < parseInt(oldval)) {
                    for (let i = 0; i < oldval - val; i++) {
                        this.handleSplits('pop', val);
                    }
                }
            }
        },
        'new_order.products': {
            handler(val) {
                let initialValue = 0;
                let qty = val.reduce(
                    (accumulator, currentValue) => accumulator + currentValue.qty,
                    initialValue
                );

                if (qty < 2) {
                    this.new_order.split_count = 2;
                    for (let key in this.new_order.solutions) {
                        if (this.new_order.solutions[key].solution_id === 1) {
                            this.new_order.solutions[key].checked = false;
                        }
                    }
                    return false;
                }
                if (qty < this.new_order.split_count) {
                    this.new_order.split_count = qty
                }
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
